import React from 'react';
import * as ds from './dataService';

import {
  StyledTextField,
  StyledRadioButtonField
} from 'modules/components/layer01';

import {
  SelectPersonInWorkEventField,
  SelectWorkTradeField
} from 'modules/components/layer04';

import { FormBaseLayout } from 'modules/components/layer10';

import {
  Button,
  Stack
} from '@mui/material';
import { SaveOnSiteWorkEvent_Input } from 'generated/graphql';
import { DateTime } from 'luxon';
import _ from 'lodash';

export type SaveOnSiteWorkEventFormProps = {
  id: string;
  projectId: string;
  handleClose: () => void;
};

export const FC = (props: SaveOnSiteWorkEventFormProps) => {
  const [
    fnSaveOnSiteWorkEventForm,
    { loading }
  ] = ds.useSaveOnSiteWorkEvent();

  const form = ds.useFormState(props.id, props.projectId);

  const handleSubmit = async (input: ds.IFormState) => {

    let tempInput: SaveOnSiteWorkEvent_Input = {
      id: input.id,
      person: {
        id: input.personId
      },
      projectId: input.projectId,
      dateWorked: DateTime.fromFormat(input.dateWorked, 'yyyy-LL-dd'),
      hoursWorked: _.toNumber(input.hoursWorked),
      numberOfSiteSubContractors: _.toNumber(input.onSiteSubContractors),
      description: input.description,
      tradeId: input.tradeId === ''
        ? null
        : input.tradeId
    };
    if (input.personId === '' && input.createPerson) {
      tempInput = {
        id: input.id,
        person: {
          firstName: input.firstName,
          lastName: input.lastName,
          phoneNumber: input.phone,
          preferredEmail: input.email
        },
        projectId: input.projectId,
        dateWorked: DateTime.fromFormat(input.dateWorked, 'yyyy-LL-dd'),
        hoursWorked: _.toNumber(input.hoursWorked),
        numberOfSiteSubContractors: _.toNumber(input.onSiteSubContractors),
        description: input.description,
        tradeId: input.tradeId === ''
          ? null
          : input.tradeId
      };
    } else if (input.personId === '' && input.createPerson && input.isOrganization) {
      tempInput = {
        id: input.id,
        person: {
          firstName: input.firstName
        },
        projectId: input.projectId,
        dateWorked: DateTime.fromFormat(input.dateWorked, 'yyyy-LL-dd'),
        hoursWorked: _.toNumber(input.hoursWorked),
        numberOfSiteSubContractors: _.toNumber(input.onSiteSubContractors),
        description: input.description,
        tradeId: input.tradeId === ''
          ? null
          : input.tradeId
      };
    }
    await fnSaveOnSiteWorkEventForm(tempInput);
    props.handleClose();
  };

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={() => {
        handleSubmit(form.formState);
      }}
      cancelButtonText='Cancel'
      successButtonText='Save'
      isLoading={loading}
    >
      <Stack
        rowGap='1.5rem'
      >
        <StyledTextField.FC
          {...form.genFieldProps('dateWorked')}
        />

        {form.formState.createPerson
          ? (
            <Stack
              direction='column'
            >
              <Button
                onClick={() => {
                  form.dispatch({
                    type: 'UPDATE',
                    payload: {
                      property: 'createPerson',
                      value: !form.formState.createPerson
                    }
                  });
                }}
              >
                Return to Select Person
              </Button>
              <StyledRadioButtonField.FC
                includeFormLabel={true}
                form={form}
                label='Is Organization'
                trueLabel='Organization'
                falseLabel='Person'
                fieldName='isOrganization'
              />
              <StyledTextField.FC
                {...form.genFieldProps('firstName')}
                label={!form.formState.isOrganization ? form.genFieldProps('firstName').label : 'Organization Name'}
              />

            </Stack>
          )
          : (
            <>
              {/* NEEDS TO BE SELECT FIELD */}
              <SelectPersonInWorkEventField.FC
                form={form}
                handleCreatePerson={() => {
                  form.dispatch({
                    type: 'UPDATE',
                    payload: {
                      property: 'createPerson',
                      value: !form.formState.createPerson
                    }
                  });
                  form.dispatch({
                    type: 'UPDATE',
                    payload: {
                      property: 'personId',
                      value: ''
                    }
                  });
                }}
                fieldName='personId'
              />
            </>
          )}
        {form.formState.createPerson && !form.formState.isOrganization && (
          <>
            <StyledTextField.FC
              {...form.genFieldProps('lastName')}
            />
            <StyledTextField.FC
              {...form.genFieldProps('email')}
            />
            <StyledTextField.FC
              {...form.genFieldProps('phone')}
            />
          </>
        )}
        <SelectWorkTradeField.FC
          form={form}
          fieldName='tradeId'
        />

        <StyledTextField.FC
          {...form.genFieldProps('onSiteSubContractors')}
        />
        <StyledTextField.FC
          {...form.genFieldProps('hoursWorked')}
        />

        <StyledTextField.FC
          {...form.genFieldProps('description')}
          minRows={3}
        />
      </Stack>

    </FormBaseLayout.FC>

  );
};
